/* @flow */
import React from 'react';

import ButtonTemplate from 'components/UIKit/Button/ButtonTemplate';
import ReviewIcon from 'components/icons/ReviewIcon';
import { Spinner } from 'components/UIKit/Spinner';

export default function ReviewButton({handleOnClick, isFetching, style, isDisabled}: Object): React.Element {
  return (
    <ButtonTemplate
      data-testid="button-review"
      style={style}
      onClick={handleOnClick}
      disabled={isFetching || isDisabled}
      PrefixComponent={
        isFetching ? <Spinner style={{width: '14px', height: '14px', margin: '0 0.25rem'}}/> : <ReviewIcon style={{margin: '0 .25rem'}}/>
      }>
      Review
    </ButtonTemplate>
  );
}
